import { injectIntl } from '@atlassian/jira-intl';
import EmptyState from './main.tsx';

export default injectIntl(EmptyState);

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { EmptyStateMessage } from './main';
